let defaultProjectState = {
	/********************************************Shared Variables (SCOPING-WIZARD, REVIEW-WIZARD) *****************************************/
	tableCreateTime: "1997-1-1",
	//Question-Comments:
	commentSet: [],

	//Titlepage:
	name: "",
	nameShort: "",
	year: 0,

	//TitlePagePeople
	author: [""],
	acknowledgements: [""],

	//Acknowledgement:
	designhelp: [],
	statistical: [],
	manuscript: [],

	//Introduction:
	intro: "",
	introprotocol: "",

	//ResearchPlan:
	planTable: {
		headers1: [
			{
				headerName: "Done",
				field: "progress",
				editable: true,
				width: 150
			},
			{
				field: "tasks",
				headerName: "Task",
				cellEditor: "agTextCellEditor",
				editable: true,
				width: 220
			},
			{
				field: "toolDescription",
				headerName: "Description",
				width: 280
			},
			{
				field: "toolLink",
				headerName: "Tool",
				width: 220
			},
			{
				field: "peopleInvolved",
				headerName: "People",
				width: 280
			},
			{
				field: "notes",
				headerName: "Notes",
				width: 300
			}
		],
		headers: [
			{ name: "progress", label: "Done" },
			{ name: "tasks", label: "Task" },
			{
				name: "toolDescription",
				label: "Description"
			},
			{ name: "toolLink", label: "Tool" },
			{
				name: "peopleInvolved",
				label: "People"
			},
			{
				name: "notes",
				label: "Notes"
			}
		],
		rows: [
			{
				progress: false,
				tasks: "PreReview preparation",
				toolDescription:
					"Agree broad review question; assemble the team; block out times",
				toolLink: [],
				notes: "",
				peopleInvolved: ""
			},
			{
				progress: false,
				tasks: "Check for and review existing SRs",
				toolDescription:
					"Search for and review existing SRs that answers the same or a similar question.",
				toolLink: [
					{ name: "PubMed", link: "https://pubmed.ncbi.nlm.nih.gov/" },
					{ name: "Prospero", link: "https://www.crd.york.ac.uk/PROSPERO/" }
				],
				notes: "",
				peopleInvolved: ""
			},
			{
				progress: false,
				tasks: "Write the protocol",
				toolDescription:
					"Provide an objective, reproducible, sound methodology for the SR, then register the protocol",
				toolLink: [{ name: "Review Wizard", link: "/planning/titlepage" }],
				notes: "",
				peopleInvolved: "",
				pageMark: "writeprotocol"
			},
			{
				progress: false,
				tasks: "Obtain set of seed studies",
				toolDescription:
					"Identify a small sample of studies relevant to the review, to aid with designing the search and data extraction form.",
				toolLink: [{ name: "TeraFarmer", link: "" }],
				notes: "",
				peopleInvolved: ""
			},
			{
				progress: false,
				tasks: "Design data extraction form",
				toolDescription:
					"Design forms for extracting study characteristics and test their usefulness/applicability",
				toolLink: [
					{ name: "Data Extraction", link: "/method/data-extraction" }
				],
				notes: "",
				peopleInvolved: ""
			},
			{
				progress: false,
				tasks: "Design systematic search strategy",
				toolDescription:
					"Design search strategy to find all relevant information (choose databases; develop search string)",
				toolLink: [
					{
						name: "Word Freq Analyzer",
						link: "https://tera-tools.com/word-freq"
					},
					{
						name: "Search Refinery",
						link: "https://tera-tools.com/searchrefiner"
					},
					{ name: "MeshMate", link: "https://tera-tools.com/meshmate" }
				],
				notes: "",
				peopleInvolved: "",
				pageMark: "searchstrategy"
			},
			{
				progress: false,
				tasks: "Run systematic search strings",
				toolDescription:
					"Run search strings in databases, trial registries, collate results in reference management system (e.g. EndNote)",
				toolLink: [
					{ name: "Polyglot", link: "https://tera-tools.com/polyglot" }
				],
				notes: "",
				peopleInvolved: "",
				pageMark: "searchstring"
			},
			{
				progress: false,
				tasks: "Deduplicate results",
				toolDescription: "Remove duplicate citations",
				toolLink: [
					{ name: "Dedupe", link: "https://tera-tools.com/deduplicator" }
				],
				notes: "",
				peopleInvolved: ""
			},
			{
				progress: false,
				tasks: "Screen abstracts",
				toolDescription:
					"Screen titles and abstracts, exclude irrelevant citations, resolve disputes",
				toolLink: [
					{ name: "Screenatron", link: "https://tera-tools.com/screenatron" },
					{ name: "Disputatron", link: "https://tera-tools.com/disputatron" }
				],
				notes: "",
				peopleInvolved: "",
				pageMark: "studyscreening"
			},
			{
				progress: false,
				tasks: "Obtain full text",
				toolDescription:
					"Download full text studies, request copies from authors, interlibrary loan",
				toolLink: [],
				notes: "",
				peopleInvolved: "",
				pageMark: "obtfulltext"
			},
			{
				progress: false,
				tasks: "Screen full text",
				toolDescription:
					"Screen full text of articles, exclude irrelevant citations, resolve disputes",
				toolLink: [
					{ name: "Screenatron", link: "https://tera-tools.com/screenatron" },
					{ name: "Disputatron", link: "https://tera-tools.com/disputatron" }
				],
				notes: "",
				peopleInvolved: "",
				pageMark: "scrfulltext"
			},
			{
				progress: false,
				tasks: "Screen trial registries",
				toolDescription:
					"Based on title and text in the trial registry entry: exclude irrelevant citations, resolve disputes",
				toolLink: [
					{ name: "Screenatron", link: "https://tera-tools.com/screenatron" },
					{ name: "Disputatron", link: "https://tera-tools.com/disputatron" }
				],
				notes: "",
				peopleInvolved: "",
				pageMark: "scrregistries"
			},
			{
				progress: false,
				tasks: "Citation search",
				toolDescription:
					"Follow citations, cited and citing, from included studies to find additional relevant studies",
				toolLink: [
					{ name: "SpiderCite", link: "https://tera-tools.com/spidercite" }
				],
				notes: "",
				peopleInvolved: ""
			},
			{
				progress: false,
				tasks: "Screen citation search",
				toolDescription:
					"Screen titles and abstracts, and full texts exclude irrelevant citations, resolve disputes",
				toolLink: [
					{ name: "Screenatron", link: "https://tera-tools.com/screenatron" },
					{ name: "Disputatron", link: "https://tera-tools.com/disputatron" }
				],
				notes: "",
				peopleInvolved: "",
				pageMark: "scrcitation"
			},
			{
				progress: false,
				tasks: "Extract data",
				toolDescription:
					"Extract study characteristics and relevant outcomes, plan data presentation",
				toolLink: [
					{ name: "Data Extraction", link: "/method/data-extraction" }
				],
				notes: "",
				peopleInvolved: "",
				pageMark: "extrdata"
			},
			{
				progress: false,
				tasks: "Risk of Bias assessment",
				toolDescription: "Assess the potential biases in included studies",
				toolLink: [],
				notes: "",
				peopleInvolved: "",
				pageMark: "Rob"
			},
			{
				progress: false,
				tasks: "Synthesise data",
				toolDescription:
					"Convert extracted outcome data to common representation (usually mean and SD)",
				toolLink: [],
				notes: "",
				peopleInvolved: "",
				pageMark: "synthdata"
			},
			{
				progress: false,
				tasks: "Meta-analysis",
				toolDescription:
					"Statistically combine the results using meta-analysis or other statistical synthesis",
				toolLink: [
					{ name: "MetaPairwise", link: "https://tera-tools.com/metapairwise" },
					{ name: "MetaInsight", link: "https://tera-tools.com/metainsight" },
					{ name: "MetaDTA", link: "https://tera-tools.com/metadta" }
				],
				notes: "",
				peopleInvolved: ""
			},
			{
				progress: false,
				tasks: "GRADE evidence",
				toolDescription:
					"Optional: rate the certainty of evidence for a treatment efficacy from high to very low",
				toolLink: [{ name: "Grade Pro", link: "https://www.gradepro.org/" }],
				notes: "",
				peopleInvolved: ""
			},
			{
				progress: false,
				tasks: "Summary of findings",
				toolDescription:
					"Optional: summarise the main findings of the SR in a table",
				toolLink: [],
				notes: "",
				peopleInvolved: ""
			},
			{
				progress: false,
				tasks: "Generate draft results",
				toolDescription: "Generate the results section of the SR",
				toolLink: [{ name: "Replicant", link: "" }],
				notes: "",
				peopleInvolved: ""
			},
			{
				progress: false,
				tasks: "Write discussion; Revise Methods; Introduction & Results",
				toolDescription:
					"Write the discussion and conclusion sections of the SR",
				toolLink: [],
				notes: "",
				peopleInvolved: ""
			},
			{
				progress: false,
				tasks: "Obtain external feedback",
				toolDescription:
					"Circulate to colleagues for external feedback, also take a break from the SR to allow thinking time about the manuscript",
				toolLink: [],
				notes: "",
				peopleInvolved: "",
				pageMark: "ack"
			},
			{
				progress: false,
				tasks: "Submit manuscript",
				toolDescription:
					"Format manuscript to meet journal requirements, complete online forms and submit manuscript",
				toolLink: [],
				notes: "",
				peopleInvolved: ""
			}
		]
	},

	//PICOT
	types: [],
	population: [{ inclusion: true }],
	intervention: [{ inclusion: true }],
	comparator: [{ inclusion: true }],
	outcomes: [{ inclusion: true, type: true }],
	setting: [{ inclusion: true }],

	//Search Strategy
	components: [],
	specialist: [],
	helper: [],
	tools: [],
	databaseTools: [],
	peerReviewer: [],
	searchAutomationTools: [],
	searchStrategyAuthors: [],

	//Search Strings for Bibliographic Databases
	databases: [],
	dateOfSearch: "",
	dateSearchedUntil: "",
	outputVersions: {},

	//Extraction:
	numberOfStudies: null,
	extractionAuthors: [],
	methods: [],
	participants: [],
	extractionTypes: [],

	//ExtractionReport:
	detable: { headers: [], rows: [] },
	detableStudyCharacteristics: { headers: [], rows: [] },
	detableSudyOutcome: { headers: [], rows: [] },
	chacteristicTable: {},
	outcometable: {},
	writeStudyCharacteristicsOnResultsSection: false,
	writeStudyOutcomesOnResultsSection: false,

	//MeasurementOfEffect:
	isMetaAnalysis: true,
	measurementOfEffectToolUsed: null,
	dichotomousOutcomes: [],
	continuousOutcomes: [],
	otherOutcomes: [],
	metaAnalysisThreshold: null,
	metaAnalysisModelUsed: null,

	//DealingWithMissingData:
	isContactedInvestigators: false,

	//SubgroupAndSensitivityAnalysis:
	isSubgroupAnalysis: false,
	subgroupAnalysis: [""],

	//AssessmentOfTheRiskOfBias:
	assessedRobAuthors: [],
	isIndependent: false,
	riskOfBiasToolUsed: [],

	//Contribution:
	conAuthors: [],

	//StudyInfomation
	reviewerRegistered: "",
	reviewProtocolDate: null,
	ifCite: true,
	/********************REVIEW-WIZARD STATE********************/

	// Search Strings (for Trial Registries):
	registries: [],
	registryDateOfSearch: "",
	registryDateSearchedUntil: "",
	// Restrictions on Publication Type
	isRestrictedByPublicationType: false,
	excludedPublicationTypes: [],
	isRestrictedByLanguage: false,
	includedLanguages: [],
	// Supplementory Methods
	conductSSearchAuthors: [],
	supplementoryMethods: [],

	//screening:
	//isTrialRegistries: false,
	//conductSSearchPeople: [],
	//numberOfTitleAbstractScreeners: null,
	//numberOfFullTextScreeners: null,
	//screenAutomationTools: [],
	screenTrialRegisPeople: [],
	titleAbstractScreeners: [],
	fullTextRetrivalAuthor: [],
	fullTextScreeners: [],
	screenCitationSearchPeople: [],
	disputeResolution: [],
	screeningToolsSelected: [],
	isPrismaFlowDiagram: false,
	isExcludedFullTextInAppendix: false,

	//Extraction:
	optionalDetail: true,
	interventions: [],
	comparators: [],
	extractionOutcomes: [{ inclusion: true, type: true }],

	//UnitOfAnalysis:
	unitOfAnalysisType: null,
	otherType: null,
	example: null,
	example2: null,

	//HeterogeneityPublicationBiases:
	isMeasuredPublicationBias: false,
	heterogeneityMeasurement: null,
	heterogeneityMeasurementOther: null,
	biasMeasurement: null,
	biasMeasurementOther: "",
	didNotMeasure: "because fewer than 10 studies were included",

	//SubgroupAndSensitivityAnalysis:
	whyNotSubgroupAnalysis: "We did not perform subgroup analysis",
	isSensitivityAnalysis: false,
	sensitivityAnalysis: [""],
	whyNotSensitivityAnalysis: "We did not perform sensitivity analysis",

	// Meta-Replicant Result (Review Only)
	metaReplicantResult: {
		file: "",
		detable: {},
		combinedContent: "",
		fileContent: "",
		detableContent: "",
		userContent: ""
	},
	metaResult: { locked: false, userChange: "" },

	/********************************************SCOPING-WIZARD STATE*****************************************/
	ScopingWizard: {
		// ViewScopingAnalysisApproach.vue
		dataDescription: [],
		resultsPresentation: [],

		// ViewScopingAnalysisOfData.vue
		dataAnalysis: [],

		// ViewScopingAssessmentOfTheRiskOfBias.vue
		riskOfBiasOptional: false,

		// ViewScopingDataExtraction.vue + ViewScopingDataExtractionReport.vue
		concepts: [],
		contexts: [],
		extractionThemes: [{ inclusion: true, type: true }],
		extractionGreyLitTypes: [],

		// ViewScopingDataExtraction.vue
		concept: [{ inclusion: true }],
		context: [{ inclusion: true }],
		// ViewScopingDataExtraction + ViewScopingPicot.vue
		theme: [{ inclusion: true, type: true }],
		greyLiteraturesSelected: []
	},

	/********************************************AUDIT-WIZARD STATE*****************************************/
	AuditWizard: {
		// ViewAuditStudyInformation.vue
		stakeholder: [""],
		stakeholderConsultation: "",
		supervisor: "",
		supervisorEmail: "",
		auditQuestionDescription: "",
		keyDocument: "",
		auditObjective: "",
		dataCollectionMethod: "",
		methodOfDataCollection: [],
		selectedExistingData: [],
		otherExistingData: "",

		// ViewAuditStudySetting.vue + ViewAuditPicot.vue
		participantsRecruitedFrom: [],
		// ViewAuditStudySetting.vue
		healthServicesParticipantsRecruited: [],
		noStudySetting: "Study setting is not defined.",

		// ViewAuditDataCollectionManagementAndAnalysis.vue
		plansForDataManagement: null,
		processesForDataQuality: null,
		statisticalEstimate: null,

		// ViewAuditEthicsAndDissemination.vue
		researchEthicsApproval: null,
		dataStorage: null,
		presentationPlans: null,

		// ViewAuditPicot.vue
		auditPopulation: "",
		measurements: [],

		// ViewAuditRecruitment.vue
		strategies: [],
		noRecruitment:
			"No strategies were implemented to achieve adequate participant enrolment.",

		// ViewAuditSampleSize.vue
		plannedSampleSize: null
	},

	/********************************************TRIAL-WIZARD STATE*****************************************/
	TrialWizard: {
		tableCreateTime: "1997-1-1",
		// ViewMethodStudySetting.vue
		settings: [],
		regions: [],

		// ViewMethodStudyInformation.vue
		trialRegistered: "",
		trialRegistNumber: "",
		protocolVersion: "",
		protocolDate: null,
		supports: "",
		sponsors: [""],
		sponsorRole: "",
		sponsorInfo: "",
		reDescription: "",
		researchObjectives: "",
		bioSpecimens: "",

		// ViewMethodSampleSize.vue
		trialType: "",
		trialTypeOther: "",
		trialDesign: [],
		studyPower: "",
		studyPowerOther: "",
		levelOfSignificance: "",
		levelOfSignificanceOther: "",
		sampleSize: "",
		effectSize: "",
		participantDropOuts: "",

		// Trial Plan
		trialplanTable: {
			headers: [
				{ name: "progress", label: "Done" },
				{ name: "tasks", label: "Task" },
				{
					name: "toolDescription",
					label: "Description"
				},
				{ name: "toolLink", label: "Tool" },
				{
					name: "peopleInvolved",
					label: "People"
				},
				{
					name: "notes",
					label: "Notes"
				}
			],
			rows: [
				{
					progress: false,
					tasks: "Write the protocol",
					toolDescription:
						"Drafting the study protocol using the trial wizard tool ideally in a group format",
					toolLink: [
						{
							name: "Trial Wizard",
							link: "/titlepage"
						}
					],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Write grant application",
					toolDescription:
						"For trials that require (additional) external funding to make them viable",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Drafting participant information brochures",
					toolDescription:
						"Information on the trial to be given to all prospective trial participants",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Drafting informed consent forms",
					toolDescription:
						"Forms needed to be signed by all prospsective trial participants before enrolment",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Design data collection forms and instruments",
					toolDescription:
						"Paper forms or computerised equivalents. Choice of scales (e.g. QoL)",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Protocol review and approval",
					toolDescription:
						"Obtaining approvals from regulatory bodies, institutional review boards (IRBs), and ethics committees",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Trial registration",
					toolDescription:
						"Register the trial on a suitable platform such as clinicaltrials.gov",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Statistical analysis plan (SAP)",
					toolDescription:
						"Separate document to the protocol where the specific details of the statistical analysis to be performed are described",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Design randomisation system",
					toolDescription:
						"Design the procedure required to randomise eligible and consenting patients to treatment groups",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Drug/device packaging and labelling",
					toolDescription: "For drug or device trials",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks:
						"Design system for monitoring drug/device shipping, restocking, returns",
					toolDescription: "For drug or device trials",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Setup of trial management committee",
					toolDescription:
						"Committee for overseeing and managing various aspects of the clinical trial",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Site selection",
					toolDescription:
						"Identifying and selecting appropriate study sites and investigators.",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Employment/recruitment of staff",
					toolDescription:
						"Additional people required to help run the clinical trial",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Design site management system",
					toolDescription:
						"Monitor site and investigator qualification, participation, ethics approvals, regulatory approvals, recruitment progress etc",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Investigator meetings",
					toolDescription:
						"Meetings to train investigators and study staff on protocol procedures, data collection, and safety reporting",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Regulatory submissions",
					toolDescription:
						"Submitting regulatory documents, such as investigational new drug (IND) applications or clinical trial applications (CTAs), to regulatory authorities for approval",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Setup of safety data monitoring committee",
					toolDescription:
						"Committee for monitoring participant safety and evaluating interim analyses that could include stopping rules due to efficacy, safety, or futility.",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Setup of outcome adjudication committee",
					toolDescription:
						"Some RCTs require clinical outcomes to be independently assessed by experts",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Recruitment strategies",
					toolDescription:
						"Developing and implementing strategies to recruit eligible participants into the trial",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Set up data entry system and data quality control checks",
					toolDescription:
						"Central data entry and forms management, or distributed data entry at sites",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Informed consent process",
					toolDescription:
						"Obtaining informed consent from participants before enrolment",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Randomisation",
					toolDescription:
						"Randomising consenting participants to treatment group",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Study monitoring",
					toolDescription:
						"Monitoring study progress, data quality, and adherence to protocol procedures through site visits, remote monitoring, and data review",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Safety monitoring",
					toolDescription:
						"Monitoring participant safety and adverse events throughout the trial, including serious adverse event (SAE) reporting and safety reviews",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Data collection and management",
					toolDescription:
						"Collecting, recording, and managing study data according to protocol requirements and regulatory standards.",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Study drug/device management",
					toolDescription:
						"Managing the distribution, storage, dispensing, and accountability of study drugs or devices.",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Finalising data in preparation for analysis",
					toolDescription:
						"Ensuring the integrity and completeness of the data",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Outcome adjudication",
					toolDescription:
						"Independent group adjudication of clinical outcomes",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Interim analyses",
					toolDescription:
						"Conducting interim analyses for safety or efficacy endpoints, if applicable",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Interim reports to ethics committees",
					toolDescription: "Usually required annually",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Final analysis",
					toolDescription:
						"Performing the final analysis of study data as per the SAP",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Manuscript preparation",
					toolDescription: "Writing the Trial manuscript for publication.",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Publication",
					toolDescription:
						"Submitting the manuscript to peer-reviewed journals for publication and responding to reviewer comments as needed",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Add results to trial register",
					toolDescription:
						"Most trial registers allow you to report the aggregate trial results",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Dissemination of findings",
					toolDescription:
						"Presentation of trial findings at meetings (local, national, international)",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Regulatory compliance",
					toolDescription:
						"Ensuring documentation of compliance with regulatory requirements, including GCP guidelines.",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Documentation",
					toolDescription:
						"Maintaining accurate and complete trial documentation",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Study closeout visits",
					toolDescription:
						"Conducting site closeout visits to ensure completion of study activities and documentation",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Final reports to ethics committees",
					toolDescription:
						"Write the final reports required by ethics committees according to their specifications",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				},
				{
					progress: false,
					tasks: "Archiving",
					toolDescription:
						"Archiving study documents, data, and materials according to regulatory requirements and sponsor policies",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
				}
			]
		},

		// ViewMethodRecruitment.vue
		recruitment: [],

		// ViewMethodParticipantTimeline.vue
		schematic: true,
		trialTimeline: "",
		trialTimelineOther: "",
		trialTimeFrequency: "",
		trialTimeFrequencyOther: "",
		timelineTable: {},
		ispreBaseline: false,

		// ViewMethodOutcomes.vue
		primary: [{ name: "", assessed: "", time: "" }],
		secondary: [{ name: "", assessed: "", time: "" }],
		adverse: [{ name: "", assessed: "", time: "" }],
		clinicalRelevance: "",

		// ViewMethodMonitoring.vue
		isCommittee: true,
		committeeDetails: "",
		committeeReporting: "",
		committeeComposition: "",
		committeeLink: "",
		committeeNotSetUpReasons: "",
		isInterimAnalysis: true,
		interimAnalysisTimePoints: "",
		interimResultsAvailable: [],
		earlyStop: "",
		finalDecisionOnTermination: [],
		interimNotConductedReasons: "",
		adverseEventsMonitored: "",
		trialAuditing: "",

		// ViewMethodInterventions.vue
		interventions: [{ name: "", materials: "", instructions: "" }],
		control: [{ name: "", materials: "", instructions: "" }],
		discontinued: [],
		adherenceMaintained: [],
		adherenceMonitored: [],
		allInstructions: "",
		prohibitedInterventions: "",

		// ViewMethodEthicsAndDissemination.vue
		approval: "",
		protocol: "",
		consent: "",
		confidentiality: "",
		declaration: "",
		access: "",
		care: "",
		dissemination: "",
		responsiblePerson: [],
		relatedDoc: "",
		guidelines: "",
		plans: "",

		// ViewMethodEligibilityCriteria.vue
		ages: [],
		ageBracket: "",
		sexes: [],
		conditions: [],
		severity: [],
		others: [],
		othersExcluded: [],
		baselineMeasurements: [],

		// ViewMethodDataCollection.vue
		collectors: [],
		collections: [],
		storage: [],
		security: [],
		dataQualityProcess: [],
		furtherDetails: [],
		primaryMeasure: [],
		secondaryMeasure: [],
		adverseEventMeasure: [],
		subgroupAnalysis: [],
		subgroupComparison: [],
		subgroupMethod: [],
		efficacyComparisons: [],
		efficacyPopulation: [],
		safetyPopulation: [],
		missingData: [],
		missingDataWhy: "",
		sensitivityAnalyses: [],

		// ViewMethodAssignmentOfInterventions.vue
		ratioRandomization: [],
		sequenceGen: [],
		concealment: "",
		blindedPeople: [],
		blindedMethod: "",
		unblinding: [],
		mechanism: [],
		concealSteps: "",

		// Question Mark:
		focusHelpQuestion: "",
		googleDocBaseURLForHelp: "",
		helpToggle: false
	},
	/********************************************ACADEMY-WIZARD STATE*****************************************/
	academyWizard: {
		//Academy Plan:
		planTable: {
			headers1: [
				{
					headerName: "Done",
					field: "progress",
					editable: true,
					width: 150
				},
				{
					field: "tasks",
					headerName: "Task",
					cellEditor: "agTextCellEditor",
					editable: true,
					width: 220
				},
				{
					field: "toolDescription",
					headerName: "Description",
					width: 280
				},
				{
					field: "toolLink",
					headerName: "Tool",
					width: 220
				},
				{
					field: "peopleInvolved",
					headerName: "People",
					width: 280
				},
				{
					field: "notes",
					headerName: "Notes",
					width: 300
				}
			],
			headers: [
				{ name: "progress", label: "Done" },
				{ name: "tasks", label: "Task" },
				{
					name: "toolDescription",
					label: "Description"
				},
				{ name: "toolLink", label: "Tool" },
				{
					name: "peopleInvolved",
					label: "People"
				},
				{
					name: "notes",
					label: "Notes"
				}
			],
			rows: [
				{
					progress: false,
					tasks: "Lead in time",
					toolDescription:
						"Time spent completing other work to allow authors to focus on the review",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "SR design meetings",
					toolDescription:
						"Time spent refining the idea, determining feasibility, assembling the team, planning timelines, deciding on roles",
					toolLink: [{ name: "Methods Wizard", link: "/planning/titlepage" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Daily administrative meetings",
					toolDescription:
						"Short daily meetings to review progress, discuss issues and document decisions",
					toolLink: [{ name: "Academy Plan", link: "/planning/rs-plan" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Formulate SR question",
					toolDescription: "Final decision on the research question (PICO)",
					toolLink: [{ name: "PICOST", link: "/method/picot" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Find and review existing or upcoming SRs",
					toolDescription:
						"Search for and review existing SRs that answers the same or a similar question.",
					toolLink: [
						{ name: "PubMed", link: "https://pubmed.ncbi.nlm.nih.gov/" },
						{ name: "Prospero", link: "https://www.crd.york.ac.uk/PROSPERO/" }
					],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Write the protocol",
					toolDescription:
						"Provide an objective, reproducible, sound methodology for the SR, then register the protocol",
					toolLink: [{ name: "Methods Wizard", link: "/planning/titlepage" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Obtain set of relevant studies",
					toolDescription:
						"Identify a small sample of studies relevant to the review, to aid with designing the search and data extraction form.",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Design data extraction form",
					toolDescription:
						"Design forms for extracting study characteristics and test their usefulness/applicability",
					toolLink: [
						{ name: "Data Extraction", link: "/method/data-extraction" }
					],
					notes: "",
					peopleInvolved: ""

					//notes: ""
				},
				{
					progress: false,
					tasks: "Design systematic search strategy",
					toolDescription:
						"Design search strategy to find all relevant information (choose databases; develop search string)",
					toolLink: [
						{
							name: "Word Freq Analyzer",
							//link: "https://sr-accelerator.com/#/wordfreq"
							link: "https://tera-tools.com/word-freq"
						},
						{
							name: "Search Refinery",
							//link: "https://sr-accelerator.com/#/searchrefinery"
							link: "https://tera-tools.com/searchrefiner"
						},
						{
							name: "MeshMate",
							//link: "https://sr-accelerator.com/#/searchrefinery"
							link: "https://tera-tools.com/meshmate"
						}
					],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Run systematic search strings",
					toolDescription:
						"Run search strings in databases, trial registries, collate results in reference management system (e.g. EndNote)",
					toolLink: [
						{
							name: "Polyglot",
							//link: "https://sr-accelerator.com/#/polyglot"
							link: "https://tera-tools.com/polyglot"
						}
					],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Deduplicate results",
					toolDescription: "Remove duplicate citations",
					toolLink: [
						{
							name: "Dedupe",
							//link: "https://sr-accelerator.com/#/deduplicator"
							link: "https://tera-tools.com/deduplicator"
						}
					],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Screen abstracts",
					toolDescription:
						"Screen titles and abstracts, exclude irrelevant citations, resolve disputes",
					toolLink: [
						{
							name: "Screenatron",
							//link: "https://sr-accelerator.com/#/screenatron"
							link: "https://tera-tools.com/screenatron"
						},
						{
							name: "Disputatron",
							//link: "https://sr-accelerator.com/#/disputatron"
							link: "https://tera-tools.com/disputatron"
						}
					],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Obtain full text",
					toolDescription:
						"Download full text studies, request copies from authors, interlibrary loan",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Screen full text",
					toolDescription:
						"Screen full text of articles, exclude irrelevant citations, resolve disputes",
					toolLink: [
						{
							name: "Screenatron",
							//link: "https://sr-accelerator.com/#/screenatron"
							link: "https://tera-tools.com/screenatron"
						},
						{
							name: "Disputatron",
							//link: "https://sr-accelerator.com/#/disputatron"
							link: "https://tera-tools.com/disputatron"
						}
					],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Screen trial registries",
					toolDescription:
						"Based on title and text in the trial registry entry: exclude irrelevant citations, resolve disputes",
					toolLink: [
						{
							name: "Screenatron",
							//link: "https://sr-accelerator.com/#/screenatron"
							link: "https://tera-tools.com/screenatron"
						},
						{
							name: "Disputatron",
							//link: "https://sr-accelerator.com/#/disputatron"
							link: "https://tera-tools.com/disputatron"
						}
					],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Citation search",
					toolDescription:
						"Follow citations, cited and citing, from included studies to find additional relevant studies",
					toolLink: [
						{
							name: "SpiderCite",
							//link: "https://sr-accelerator.com/#/spidercite"
							link: "https://tera-tools.com/spidercite"
						}
					],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Screen citation search",
					toolDescription:
						"Screen titles and abstracts, and full texts exclude irrelevant citations, resolve disputes",
					toolLink: [
						{
							name: "Screenatron",
							//link: "https://sr-accelerator.com/#/screenatron"
							link: "https://tera-tools.com/screenatron"
						},
						{
							name: "Disputatron",
							//link: "https://sr-accelerator.com/#/disputatron"
							link: "https://tera-tools.com/disputatron"
						}
					],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Extract data",
					toolDescription:
						"Extract study characteristics and relevant outcomes, plan data presentation",
					toolLink: [
						{ name: "Data Extraction", link: "/method/data-extraction" }
					],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Risk of Bias assessment",
					toolDescription: "Assess the potential biases in included studies",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Synthesise data",
					toolDescription:
						"Convert extracted outcome data to common representation (usually mean and SD)",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Meta-analysis",
					toolDescription:
						"Statistically combine the results using meta-analysis or other statistical synthesis",
					toolLink: [
						{
							name: "MetaPairwise",
							link: "https://tera-tools.com/metapairwise"
						},
						{
							name: "MetaInsight",
							link: "https://tera-tools.com/metainsight"
						},
						{
							name: "MetaDTA",
							link: "https://tera-tools.com/metadta"
						}
					],
					notes: "",
					peopleInvolved: "",
					pageMark: "metaanalysis"
				},
				{
					progress: false,
					tasks: "GRADE evidence",
					toolDescription:
						"Optional: rate the certainty of evidence for a treatment efficacy from high to very low",
					toolLink: [{ name: "Grade Pro", link: "https://www.gradepro.org/" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Summary of findings",
					toolDescription:
						"Optional: summarise the main findings of the SR in a table",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Update systematic search strategy",
					toolDescription:
						"Optional: repeat the search to find new studies published since the initial search, especially if search more than a year old",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Revise introduction",
					toolDescription:
						"Revise the introduction section from the SR protocol",
					toolLink: [{ name: "Introduction", link: "/introduction" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Revise methods",
					toolDescription: "Revise the methods section from the SR protocol",
					toolLink: [{ name: "Methods Wizard", link: "/planning/titlepage" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Write results",
					toolDescription: "Write the results section of the SR",
					toolLink: [
						{
							name: "",
							link: ""
						}
					],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Write discussion",
					toolDescription:
						"Write the discussion and conclusion sections of the SR",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Obtain external feedback",
					toolDescription:
						"Circulate to colleagues for external feedback, also take a break from the SR to allow thinking time about the manuscript",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Submit manuscript",
					toolDescription:
						"Format manuscript to meet journal requirements, complete online forms and submit manuscript",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Reformat and resubmit manuscript",
					toolDescription:
						"If rejected, reformat manuscript to meet new journal requirements and standards",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Manuscript revisions",
					toolDescription:
						"Revise manuscript due to comments from peer reviewers, and resubmit it",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Manuscript accepted",
					toolDescription:
						"Review manuscript, and copy edit any errors or issues",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				},
				{
					progress: false,
					tasks: "Manuscript published",
					toolDescription:
						"Send the details around to everyone you know, and enjoy the kudos",
					toolLink: [{ name: "", link: "" }],
					notes: "",
					peopleInvolved: ""
					//notes: ""
				}
			]
		},
		file: ""
	}
};

export { defaultProjectState };
